import styled from 'styled-components';


export const ToSecondaryAnchor = styled.a`
  color: var(--color-gray2);
  :hover{
    color:var(--color-secondary);
  }
`;


export const HoverUnderline = styled.span`
  text-decoration: none;
  padding-bottom:0.2em;
  margin: 0 4px;
  background-image: linear-gradient(var(--color-secondary), var(--color-secondary));
  background-position: 50% 100%;
  background-repeat: no-repeat;
  background-size: 0% 2px;
  color:var(--color-gray1);
  transition: background-size cubic-bezier(0,.5,0,1) 0.3s;
  :hover,
  :focus {
    text-decoration: none;
    background-size: 100% 2px;
  }
`;